/* ============================================================
   EPICLABS® · CULT LAYER engine  v1.0
   3D tilt + cursor spotlight + magnetic CTAs + reveal.
   Auto-realza componentes existentes sin tocar el HTML.
   ============================================================ */
(function(){
  if (window.__epicCult) return; window.__epicCult = true;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia && window.matchMedia('(pointer:fine)').matches;

  /* Selectores de tarjetas que reciben tilt + spotlight.
     RESTRAINT élite: SOLO la tarjeta destacada (protocolo recomendado / bundle).
     El resto queda quieto = más caro, más rápido. */
  var CARD_SEL = [
    '.epic-protocols__card--featured', '.epic-bb__summary-card', '.epic-pg__cta-card'
  ].join(',');

  /* Degradado animado SOLO en títulos clave de marketing (curado, sin exagerar).
     No incluye el hero ni los títulos utilitarios de la app. Auto claro/oscuro. */
  var GRAD_SEL = [
    '.epic-protocols__title','.epic-col__title','.epic-bb__title','.epic-bd__title',
    '.epic-pl__title','.epic-benefits__title','.epic-vs__title','.epic-ab__title',
    '.epic-edu__title','.epic-tr__title','.epic-mc__title','.epic-wk__title','.pe-section__title'
  ].join(',');

  /* Luminancia del fondo más cercano (para elegir gradiente claro u oscuro) */
  function bgLuminance(el){
    var node = el, guard = 0;
    while (node && node !== document.documentElement && guard < 30){
      guard++;
      var bg = getComputedStyle(node).backgroundColor;
      if (bg){
        var m = bg.match(/[\d.]+/g);
        if (m){
          var r=+m[0], g=+m[1], b=+m[2], a=(m[3]!==undefined?+m[3]:1);
          if (a > 0.35) return 0.299*r + 0.587*g + 0.114*b;
        }
      }
      node = node.parentElement;
    }
    return 255; /* asume claro */
  }

  function init(){
    /* ── Gradient headings (auto claro/oscuro según fondo) ── */
    document.querySelectorAll(GRAD_SEL).forEach(function(h){
      if (h.__epicGrad) return; h.__epicGrad = true;
      h.classList.add(bgLuminance(h) < 130 ? 'epic-grad-text--light' : 'epic-grad-text');
    });

    /* ── CTAs magnéticos en todo el sitio (se enlazan abajo) ── */
    var CTA_SEL = [
      '.epic-protocols__cta','.pe__btn-primary','.epic-col__btn--lg','.epic-ab__btn--primary',
      '.epic-ct__btn--primary','.epic-bb__cta','.epic-hv__cta','.epic-ap__btn--primary'
    ].join(',');
    document.querySelectorAll(CTA_SEL).forEach(function(b){ if(!b.hasAttribute('data-epic-magnetic')) b.setAttribute('data-epic-magnetic',''); });

    /* ── Border Beam en elementos destacados (curado) ── */
    if (!reduce) {
      var BEAM_SEL = ['.epic-bb__summary-card'].join(',');
      document.querySelectorAll(BEAM_SEL).forEach(function(el){ el.classList.add('epic-beam'); });
    }

    /* ── Tilt + spotlight en cards (solo desktop con puntero fino) ── */
    if (fine && !reduce) {
      document.querySelectorAll(CARD_SEL).forEach(function(card){
        if (card.__epicCult) return; card.__epicCult = true;
        card.classList.add('epic-spot');
        card.setAttribute('data-epic-tilt','');
        var rect=null;
        card.addEventListener('pointerenter', function(){ rect = card.getBoundingClientRect(); card.classList.add('epic-tilting'); });
        card.addEventListener('pointermove', function(e){
          if (!rect) rect = card.getBoundingClientRect();
          var px = (e.clientX - rect.left) / rect.width;
          var py = (e.clientY - rect.top) / rect.height;
          var rx = (py - 0.5) * -5;   /* grados */
          var ry = (px - 0.5) * 6;
          card.style.transform = 'perspective(900px) rotateX('+rx.toFixed(2)+'deg) rotateY('+ry.toFixed(2)+'deg) translateY(-4px)';
          card.style.setProperty('--epic-mx', (px*100).toFixed(1)+'%');
          card.style.setProperty('--epic-my', (py*100).toFixed(1)+'%');
        });
        card.addEventListener('pointerleave', function(){ card.style.transform=''; card.classList.remove('epic-tilting'); rect=null; });
      });
    }

    /* ── Magnetic CTAs ── */
    if (fine && !reduce) {
      document.querySelectorAll('[data-epic-magnetic]').forEach(function(btn){
        if (btn.__epicMag) return; btn.__epicMag = true;
        btn.addEventListener('pointermove', function(e){
          var r = btn.getBoundingClientRect();
          var x = (e.clientX - r.left - r.width/2) * 0.18;
          var y = (e.clientY - r.top - r.height/2) * 0.28;
          btn.style.transform = 'translate('+x.toFixed(1)+'px,'+y.toFixed(1)+'px)';
        });
        btn.addEventListener('pointerleave', function(){ btn.style.transform=''; });
      });
    }

    /* ── Reveal premium blur-in ── */
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function(es){
        es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('epic-in'); io.unobserve(e.target); } });
      }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });
      document.querySelectorAll('[data-epic-cult-in]:not(.epic-in)').forEach(function(el){ io.observe(el); });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();

/* ============================================================
   Guardián de cajones: oculta flotantes (WhatsApp, prueba social,
   Dynamic Island, tab bar) cuando el menú o el carrito están abiertos.
   Solo alterna la clase `.epic-drawer-open` en <body> — NO toca el scroll,
   NO agrega listeners de touchmove, NO modifica los cajones → 100% seguro.

   El bloqueo de scroll de fondo lo maneja el mecanismo NATIVO del tema
   (Dawn: clase `overflow-hidden-*` en <body> al abrir el <details>). Con
   `sticky_header_type: "always"` el header NUNCA se esconde, así que el
   drawer (position:absolute anclado al header fijo) queda pegado al viewport
   desde cualquier posición de scroll y, al cerrar, el fondo conserva su
   posición exacta (overflow:hidden no mueve el scroll → sin saltos).

   HISTÓRICO: aquí vivía un "touch-lock" que hacía preventDefault a todo
   touchmove fuera del drawer y solo se liberaba cuando el <details> cerraba
   (rAF de closeAnimation → toggle). Si el menú se abría cerca del footer y
   esa cadena se interrumpía, el body quedaba con el scroll congelado en
   ambas direcciones sin recuperación. Eliminado por orden de Roberto: el
   tema nativo manda. NO re-agregar bloqueadores de touchmove al body. */
(function(){
  if (window.__epicDrawerGuard) return; window.__epicDrawerGuard = true;

  function setup(){
    var body = document.body;
    var md = document.querySelector('.menu-drawer');
    var det = md ? md.closest('details') : null;
    var cart = document.querySelector('cart-drawer, .cart-drawer, #CartDrawer');
    function sync(){
      var open = false;
      if (det && det.open) open = true;
      if (cart && (cart.classList.contains('active') || cart.classList.contains('is-open') || cart.classList.contains('animate') || cart.hasAttribute('open'))) open = true;
      body.classList.toggle('epic-drawer-open', open);
    }
    if (det) det.addEventListener('toggle', sync);
    if (cart && window.MutationObserver){ try { new MutationObserver(sync).observe(cart, { attributes:true, attributeFilter:['class','open','aria-hidden'] }); } catch(e){} }
    document.addEventListener('click', function(){ setTimeout(sync, 60); }, true);
    document.addEventListener('keyup', function(e){ if(e.key==='Escape') setTimeout(sync, 60); });
    sync();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup); else setup();
  document.addEventListener('shopify:section:load', setup);
})();

/* ============================================================
   Menú móvil: comportamiento NATIVO colapsable.
   (Antes forzábamos todos los grupos abiertos, lo que llenaba el cajón
   de subítems y "enterraba"/retrasaba los títulos generales. Ahora los
   encabezados de sección se ven al instante y cada grupo se expande al tocar.)
   ============================================================ */
